module.exports = __webpack_public_path__ + "static/media/bl.ad7f03b2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/bl.png
// module id = 1800
// module chunks = 0